import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=511ea2b9"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511ea2b9')) {
      api.createRecord('511ea2b9', component.options)
    } else {
      api.reload('511ea2b9', component.options)
    }
    module.hot.accept("./DocumentIcon.vue?vue&type=template&id=511ea2b9", function () {
      api.rerender('511ea2b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DocumentIcon.vue"
export default component.exports